
// // 跳转PGC评论页
// export const navigateToWeappPgcCommentPage = (id: string) => {
// 	wx.miniProgram.navigateTo({ url: `/packages/community/pages/pgcComment/index?id=${id}` });
// };
// // 跳转小程序他人空间页
// export const navigateToWeappUserPage = (userId: string) => {
// 	// console.log(wx, wx.miniProgram.getEnv(), "-----get env");
// 	wx.miniProgram.navigateTo({ url: `/pages/user/index?id=${userId}` });
// };
// // 跳转小程序话题页
// export const navigateToWeappTopicPage = (id: string) => {
// 	wx.miniProgram.navigateTo({ url: `/packages/community/pages/topic/index?id=${id}` });
// };
// // 跳转小程序UGC
// export const navigateToWeappUGC = (id: string) => {
// 	wx.miniProgram.navigateTo({ url: `/packages/community/pages/ugc/index?id=${id}` });
// };
// // 跳转小程序专题详情页
// export const navigateToWeappSpecialPage = (id: string) => {
// 	wx.miniProgram.navigateTo({ url: `/packages/community/pages/special/detail/index?id=${id}` });
// };

// // 跳转至小程序登录页，该登录页主要用于从webview唤起的登录页面
// export const navigateToWeappLoginPage = (source = "") => {
// 	// wx.miniProgram.redirectTo({ url: `/pages/loginWebView/index?redirect=${window.location.href}` });
// 	wx.miniProgram.redirectTo({ url: `/pages/login/index?redirect=${encodeURIComponent(window.location.href)}&source=${source}` });
// };

// 跳转至小程序社区webview
export const navigateToCommunityWeappWebViewPage = (url: string) => {
	console.log("url", url);
	wx.miniProgram.navigateTo({ url: `/pages/webview/index?url=${encodeURIComponent(url)}` });
};

export const navigateToWeappCR = () => {
	// wx.miniProgram.redirectTo({ url: `/pages/chat/index` });
	wx.miniProgram.redirectTo({ url: `/pages/customerService/index` }); // 客服中转页, 会读取配置并判断走哪些逻辑
};
